// ============================================
// モジュール読み込み
// ============================================
import initCommonScript from "./libs/common";
import initObserveAnimation from "./libs/animation/initObserveAnimation";
import initTextAnimation from "./libs/animation/initTextAnimation";

// 共通script
initCommonScript();

// スクロール連動アニメーション
initObserveAnimation();

//テキストアニメーション
initTextAnimation();
